/**
 * テナント未確定（saas-admin / 未ログイン / doc 不在）時に使う汎用デフォルト。
 * 各アプリは自分用の fallback（アプリ名など）を `resolveBrand` の第 2 引数で渡せる。
 */
export const DEFAULT_BRAND = {
    brandName: 'テナント',
    primaryColor: '#0F172A',
};
/**
 * `Tenant` doc からブランド表示値を解決する pure 関数。
 *
 * - tenant が `null`（saas-admin / 未ログイン / doc 不在）→ `fallback` をそのまま返す
 * - customizations.brandName が空でなければ採用、無ければ shopName、最後に `fallback.brandName`
 * - logoUrl は空文字列を無視し、無ければ `fallback.logoUrl`（通常 undefined = ロゴ無し）
 * - primaryColor は空文字列を無視し、無ければ `fallback.primaryColor`
 *
 * 壊れた doc（customizations 欠損）でも throw しない防御的実装。
 */
export function resolveBrand(tenant, fallback = DEFAULT_BRAND) {
    if (!tenant)
        return fallback;
    const c = tenant.customizations ?? {};
    const brandName = (typeof c.brandName === 'string' && c.brandName.trim().length > 0
        ? c.brandName.trim()
        : undefined) ??
        (tenant.shopName.trim().length > 0 ? tenant.shopName : fallback.brandName);
    const logoUrl = typeof c.logoUrl === 'string' && c.logoUrl.trim().length > 0
        ? c.logoUrl.trim()
        : fallback.logoUrl;
    const primaryColor = typeof c.primaryColor === 'string' && c.primaryColor.trim().length > 0
        ? c.primaryColor.trim()
        : fallback.primaryColor;
    return { brandName, logoUrl, primaryColor };
}
//# sourceMappingURL=tenantBrand.js.map